import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// Layout
import Navbar from './Components/Navbar';
import FooterBar from './Components/FooterBar';
import LegalFooter from './Components/LegalFooter';
import FloatingWhatsapp from './Components/FloatingWhatsapp';

// Pages
import Home from './Components/Home';
import Servicios from './Components/N_servicios';
import Plus from './Components/N_plus';
import P_tiempos from './Components/P_tiempos';
import Hablamos from './Components/Hablamos';

// Assets
import logo from './assets/transparente_cursos_inteligencia_artificial_educacion_eduialogic.png';

// Styles
import './App.css';

const App = () => {
  return (
    <div className="App">
      <Router>

        {/* Logo + Navbar */}
        <div className="logo-navbar-wrapper">
          <a href="/">
            <img
              src={logo}
              alt="EduIAlogic logo"
              className="floating-logo-aligned"
            />
          </a>
          <Navbar />
        </div>

        {/* Routes */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/N_servicios" element={<Servicios />} />
          <Route path="/N_plus" element={<Plus />} />
          <Route path="/P_tiempos" element={<P_tiempos />} />
          <Route path="/Hablamos" element={<Hablamos />} />
        </Routes>

        {/* Floating & Footers */}
        <FloatingWhatsapp />
        <LegalFooter />
        <FooterBar />

      </Router>
    </div>
  );
};

export default App;
